// src/hooks/useAuthGuard.js
import { useNavigate } from "react-router-dom";

export const useAuthGuard = () => {
  const navigate = useNavigate();

  const requireAuth = (callback, showToast = null) => {
    // Check for user in localStorage
    const userStr = localStorage.getItem("kkb_user");
    const token = localStorage.getItem("kkb_token");

    if (!userStr || !token) {
      // Store the intended action and current page
      sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
      sessionStorage.setItem("intendedAction", "add_to_cart");

      // Show toast message if available
      if (showToast && typeof showToast === "function") {
        showToast("Please login to add items to cart", "warning");
      } else {
        alert("Please login to add items to cart");
      }

      navigate("/account");
      return false;
    }

    if (callback && typeof callback === "function") {
      callback();
    }
    return true;
  };

  const isAuthenticated = () => {
    const userStr = localStorage.getItem("kkb_user");
    const token = localStorage.getItem("kkb_token");
    return !!(userStr && token);
  };

  const getUser = () => {
    const userStr = localStorage.getItem("kkb_user");
    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch (e) {
        return null;
      }
    }
    return null;
  };

  return { requireAuth, isAuthenticated, getUser };
};
